export const createConfirmation = 'CREATE.CONFIRM';
export const updateConfirmation = 'UPDATE.CONFIRM';
export const deleteConfirmation = 'DELETE.CONFIRM';
export const redoContactLogConfirmation = 'CONTACT_LOG.REDO.CONFIRM';
export const defaultModalMaxWidth = '90vw';

export const mediumModalMaxWidth = '960px';
